/**
 * render-flags.ts — v0M5.1 (2026-07-25).
 *
 * Client-side render-time overrides that don't belong on the sim state.
 * These are dev/playtest knobs consumed by the renderer (v0M5.2+) and
 * toggled from the dev-tools console (`~` key).
 *
 * Deliberately NOT sim state — determinism unaffected, MP-safe by
 * construction (each client mutates locally; nothing echoes into the
 * command stream).
 *
 * Consumers:
 *   - `renderFog()` in the v0M5.2 fog layer reads `revealAllCells` and,
 *     when true, treats every cell as state 4 for the local player
 *     regardless of the sim `Visibility` map.
 *   - `dev-console.ts` mutates these directly via the "Vision" section.
 */

interface RenderFlags {
  /**
   * When true, the fog renderer draws every cell at state 4 (visible +
   * detection) regardless of the sim visibility map — reveals the whole
   * map + all enemy entities including invisibles. Debug-only.
   */
  revealAllCells: boolean;
}

const flags: RenderFlags = {
  revealAllCells: false,
};

export function getRenderFlags(): Readonly<RenderFlags> {
  return flags;
}

export function setRevealAllCells(value: boolean): void {
  flags.revealAllCells = value;
}

export function toggleRevealAllCells(): boolean {
  flags.revealAllCells = !flags.revealAllCells;
  return flags.revealAllCells;
}
